<div
  [formGroup]="formGroup"
  id="input-files-container"
  [class.small]="size === 's'"
  [class.medium]="size === 'm'"
  [class.large]="size === 'l'"
>
  <input
    *ngIf="variant === 'native'"
    type="file"
    id="input-files-native"
    [class.control]="true"
    [class.small]="size === 's'"
    [class.medium]="size === 'm'"
    [class.large]="size === 'l'"
    [style]="styles"
    [class]="class"
    [multiple]="multiple"
    [accept]="accept"
    #nativeFilePicker
    (change)="handleOnInputFileChange($event)"
    (click)="$event.target.value = null"
    style="
      visibility: hidden;
      position: absolute;
      top: -10000px;
      left: -10000px;
    "
  />
  <button
    id="input-files-native"
    *ngIf="variant === 'native'"
    [class.small]="size === 's'"
    [class.medium]="size === 'm'"
    [class.large]="size === 'l'"
    [style]="styles"
    [class]="class"
    (click)="handleOnClickOpenFileManager()"
  >
    <ng-container *ngIf="size === 's'">
      <div class="content small">
        <tui-svg [src]="icon"></tui-svg>
      </div>
    </ng-container>
    <ng-container *ngIf="size === 'm'">
      <div class="content medium">
        <div class="input-file-dropzone-label"> {{ link }}</div>
      </div>
    </ng-container>
    <ng-container *ngIf="size === 'l'">
      <div class="content large">
        <tui-marker-icon
          mode="link"
          [src]="icon"
        ></tui-marker-icon>
        <div class="input-file-dropzone-label"> {{ link }}{{ label }} </div>
      </div>
    </ng-container>
  </button>

  <tui-input-files
    id="input-files"
    *ngIf="variant === 'taigaui'"
    [class.control]="true"
    [class.small]="size === 's'"
    [class.medium]="size === 'm'"
    [class.large]="size === 'l'"
    [style]="styles"
    [class]="class"
    [formControl]="formControl"
    [multiple]="multiple"
    [accept]="accept"
    [label]="label"
    [link]="link"
    [maxFileSize]="maxFileSize"
  >
    <ng-template let-dragged>
      <div
        *ngIf="false; else base"
        class="content"
      ></div>
      <ng-template #base>
        <ng-container *ngIf="size === 's'">
          <div class="content small">
            <tui-svg [src]="icon"></tui-svg>
          </div>
        </ng-container>
        <ng-container *ngIf="size === 'm'">
          <div class="content medium">
            <a tuiLink>{{ link }}</a>
          </div>
        </ng-container>
        <ng-container *ngIf="size === 'l'">
          <div class="content large">
            <tui-marker-icon
              mode="link"
              [src]="icon"
            ></tui-marker-icon>
            <div>
              <a tuiLink>{{ link }}</a>
              {{ label }}
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ng-template>
  </tui-input-files>

  <button
    *ngIf="files.length > 0 && size === 's' && showAddedFiles"
    tuiButton
    id="view-added-files-btn"
    appearance="flat"
    nativeId="view-added-files-btn"
    shape="square"
    size="m"
    [tuiDropdown]="addedFiles"
    [tuiDropdownManual]="openDropdown"
    (click)="openDropdown = !openDropdown"
  >
    {{ files.length }}
  </button>

  <ng-container *ngIf="files.length > 0 && size !== 's' && showAddedFiles">
    <ng-container
      *ngTemplateOutlet="addedFiles; context: { files: files }"
    ></ng-container>
  </ng-container>

  <div
    *ngIf="files.length === 0 && size !== 's' && showAddedFiles"
    id="no-files-added"
    [class.small]="size === 's'"
    [class.medium]="size === 'm'"
    [class.large]="size === 'l'"
  >
    {{ size !== "s" ? "No Files Added" : "0" }}
  </div>
</div>

<ng-template
  #addedFiles
  let-files="files"
>
  <div
    id="files-added"
    [class.small]="size === 's'"
    [class.medium]="size === 'm'"
    [class.large]="size === 'l'"
  >
    <tui-files [max]="2">
      <ng-container
        class="file-parent"
        *ngFor="let file of normalFiles"
      >
        <tui-file
          [showDelete]="file?.showDelete ?? true"
          [file]="file"
          state="normal"
          showSize="true"
          size="l"
          (removed)="removeFile(file)"
        >
          <kwikui-button
            *ngIf="showViewButton"
            class="view-button-underline"
            [pseudoHover]="showViewButton?.viewButtonPseudoHover"
            appearance="flat"
            size="s"
            style="--tui-padding: 0px"
            [label]="showViewButton?.label"
            (click)="fileClick(file)"
          ></kwikui-button>
        </tui-file>
      </ng-container>

      <ng-container
        class="file-parent"
        *ngFor="let file of errorFiles"
      >
        <tui-file
          [showDelete]="file?.showDelete ?? true"
          [file]="file"
          state="error"
          showSize="true"
          size="l"
          (removed)="removeFile(file)"
        >
          <kwikui-button
            *ngIf="showViewButton"
            class="view-button-underline"
            [pseudoHover]="showViewButton?.viewButtonPseudoHover"
            appearance="flat"
            size="s"
            style="--tui-padding: 0px"
            [label]="showViewButton?.label"
            (click)="fileClick(file)"
          ></kwikui-button>
        </tui-file>
      </ng-container>

      <ng-container
        class="file-parent"
        *ngFor="let file of loadingFiles"
      >
        <tui-file
          [showDelete]="file?.showDelete ?? true"
          [file]="file"
          state="loading"
          showSize="true"
          size="l"
        >
          <kwikui-button
            *ngIf="showViewButton"
            class="view-button-underline"
            [pseudoHover]="showViewButton?.viewButtonPseudoHover"
            appearance="flat"
            size="s"
            style="--tui-padding: 0px"
            [label]="showViewButton?.label"
            (click)="fileClick(file)"
          ></kwikui-button>
        </tui-file>
      </ng-container>

      <ng-container
        class="file-parent"
        *ngFor="let file of deletedFiles"
      >
        <tui-file
          [showDelete]="file?.showDelete ?? true"
          [file]="file"
          state="deleted"
          showSize="true"
          size="l"
        >
          <kwikui-button
            *ngIf="showViewButton"
            class="view-button-underline"
            [pseudoHover]="showViewButton?.viewButtonPseudoHover"
            appearance="flat"
            size="s"
            style="--tui-padding: 0px"
            [label]="showViewButton?.label"
            (click)="fileClick(file)"
          ></kwikui-button>
        </tui-file>
      </ng-container>
    </tui-files>
  </div>
</ng-template>
